/** @format */

//!!! TO BE DEPRECATED
export function deprecatedUrlSanitizer(str: string) {
  return str.replace(/\s+/g, '-').replace(/\?/g, '').replace(/,/g, '').toLowerCase();
}

//!!! TO BE TESTED
export function urlSanitizer(str: string) {
  const [baseUrl, queryString] = str.split('?');
  const sanitizedBase = baseUrl
    .replace(/\s+/g, '-') // spaces to hyphens
    .replace(/\?/g, '') // remove question marks
    .replace(/,/g, '') // remove commas
    .replace(/(https?:\/\/)|(\/)+/g, '$1$2') // Preserve https:// but clean other double slashes
    .toLowerCase();

  // If there are query parameters, add them back
  if (queryString) return `${sanitizedBase}?${queryString}`;

  // If no query parameters, add trailing slash
  return sanitizedBase.replace(/\/?$/, '/');
}
